// extracted by mini-css-extract-plugin
export default {"commonButton":"CommonButton_commonButton__oZOm2"};